<div class="notice-read">

  <div class="notice-read-item" *ngFor="let notice of notices">
    <div class="notice-read-header" (click)="toggle(notice)">
      <div class="notice-read-title">{{ notice.title }}</div>
      <div class="notice-read-date">{{ 'NOTICE.READAT' | translate }} {{ notice.readAt | datehour }}</div>
    </div>

    <div class="notice-read-body" *ngIf="isExpanded(notice)">
      <div [innerHTML]="notice.bodyHtml"></div>

      <div class="notice-read-answers" *ngIf="notice.questions != null && notice.questions.length > 0">
        <div class="notice-read-answer" *ngFor="let question of notice.questions">
          <span class="question">{{ question.questionText }}</span>
          <span class="answer">{{ answerLabel(question) }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="hint" *ngIf="notices.length === 0">{{ 'NOTICE.READ.EMPTY' | translate }}</div>
</div>
